import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  summaryTableDataSelector,
  summaryTableSortSelector,
} from '@store/aiAlerts/summary/selectors';
import { setSummaryTableSort } from '@store/aiAlerts/summary/actions';
import { getColumns, rowRenderer } from './formatter';
import { Wrapper, StyledBaseTable } from './styled';
import Table from '@src/components/common/Table';

const SummaryTable = ({ type, alertFeatureFlags }) => {
  const sortBy = useSelector(summaryTableSortSelector);
  const { isAlertPartnerAccount } = alertFeatureFlags;
  const dataSource = useSelector(summaryTableDataSelector);
  const dispatch = useDispatch();

  const columns = getColumns(type, isAlertPartnerAccount);

  const onColumnSort = ({ key, order }) => {
    dispatch(
      setSummaryTableSort({
        key,
        order,
      }),
    );
  };

  return (
    <Wrapper>
      <Table
        data={dataSource}
        columns={columns}
        headerHeight={50}
        estimatedRowHeight={100}
        expandColumnKey={'cumulativeImpactedUniques'}
        onColumnSort={onColumnSort}
        sortBy={sortBy}
        rowRenderer={rowRenderer}
      />
    </Wrapper>
  );
};

export default SummaryTable;
